import React from 'react';
import { withRouter } from 'found';
import { connect } from 'react-redux';
import Sticky from 'react-stickynode';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Head from '../../../components/Head';
import AppsList from '../components/apps/AppsList';
import FilterBar from '../components/apps/FilterBar';
import { setFilterQuery, setFilterType, setFilterVendor } from '../actions/apps';
import { getVisibleApps } from '../reducers/apps/list';

class Apps extends React.Component {
  render() {
    const { apps, filter, setFilterQueryFn, setFilterVendorFn, setFilterTypeFn } = this.props;
    return (
      <>
        <Head title="Components" />
        <Sticky activeClass="open-apps-filter-sticky-wrapper">
          <div className="open-apps-filter-wrapper">
            <div className="container">
              <FilterBar
                filter={filter}
                setFilterQueryFn={setFilterQueryFn}
                setFilterVendorFn={setFilterVendorFn}
                setFilterTypeFn={setFilterTypeFn}
              />
            </div>
          </div>
        </Sticky>
        <hr />
        <div className="container">
          {apps.length !== 0 ? (
            <AppsList apps={apps} />
          ) : (
            <div className="text-center margin-vertical-4em">
              <p>
                <FontAwesomeIcon icon={['far', 'meh']} size="3x" />
              </p>
              <p className="font-size-1-5em">
                Could not find any component matching your criteria.
              </p>
            </div>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const localState = state.open.apps;
  return {
    apps: getVisibleApps(localState.list, localState.filter),
    filter: localState.filter,
  };
};

Apps = withRouter(
  connect(mapStateToProps, {
    setFilterQueryFn: setFilterQuery,
    setFilterVendorFn: setFilterVendor,
    setFilterTypeFn: setFilterType,
  })(Apps)
);

export default Apps;
